<template>
  <section
    style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    "
  >
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
              <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
              Ajouter un nouveau Sous Theme
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="addCard">
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-1">
          <v-form ref="form" lazy-validation>
            <v-card-title>Ajouter un nouveau Sous Theme</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="PropheteName"
                    label="Nom"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="PropheteNameEn"
                    label="Nom en anglais"
                    outlined
                    required
                  ></v-text-field>
                </v-col>

               
                <v-col cols="auto" style="margin-top: 16px">
                  <span>Premium:</span>
                </v-col>
                <v-col cols="auto">
                  <v-switch v-model="isLocked" hide-details inset></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-select
                    v-model="theme"
                    :items="themeArray"
                    clearable
                    label="Theme"
                    item-text="title"
                    item-value="id"
                    outlined
                  ></v-select
                ></v-col>
                 <v-col cols="12" sm="12" md="6">
                  <vue-upload-multiple-image
                    v-if="PropheteName && PropheteNameEn"
                    v-model="images"
                    :data-images="images"
                    name="images"
                    accept="image/*	"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @images-updated="handleImagesUpdated"
                  >
                  </vue-upload-multiple-image>

                  <v-progress-linear
                    v-if="showlowding && uploadPercentage < 100"
                    style="max-width: 190px; margin-left: 160px"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="PropheteName.length <= 0 || !prophete.imgDBUrlId"
                      class="info"
                      @click="validate"
                      :loading="isButtonLoading"
                    >
                      {{ isButtonLoading ? "Chargement..." : "Suivant" }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Sous Thème</v-card-title>
      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>
      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        :headers="headers"
        :items="PropheteArray"
        class="elevation-1"
        item-key="id"
      >
        <!-- <template v-slot:item.imageUrl="{ item }">
          <v-img style="margin: 10px" :src="item.imageUrl" width="65" height="65" />
          <v-divider></v-divider>
        </template> -->
        <template v-slot:[`item.imageUrl`]="{ item }">
          <v-img
            v-if="item.imgDBType != 'svg'"
            :src="item.imgUrl"
            width="65"
            height="65"
          />
          <div
            v-if="item.imgDBType === 'svg'"
            v-html="item.svgContent"
          ></div>
          <v-divider></v-divider>
        </template>
        <template v-slot:[`item.isLocked`]="{ item }">
          <v-icon color="warning" v-if="item.isLocked">
            {{ icons.mdiLock }}
          </v-icon>
          <v-icon color="#00a325" v-if="!item.isLocked">
            {{ icons.mdiLockOpen }}
          </v-icon>
        </template>
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditProphete(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.id)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddProphete" max-width="530">
        <v-card class="pa-6 pa-sm-6" max-width="600px">
          <v-card-title style="text-align: center" class="justify-center mb-2"
            >Etes vous sur de vouloir ajouter le Prophete
          </v-card-title>
          <v-card-subtitle
            class="text-h6 mb-3"
            style="text-align: center; color: #24aeb1"
            >{{ PropheteName }}
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="ajoutProphete()"
              :color="loadingbtn ? 'grey' : 'info'"
              :disabled="loadingbtn"
            >
              <span v-if="!loadingbtn">Confirmer</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
            <v-btn
              :color="loadingbtn ? 'grey' : 'error'"
              :disabled="loadingbtn"
              @click="reinitialisationFormulaire()"
            >
              <span v-if="!loadingbtn">Annuler</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteProphete" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le Prophete ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteProphete = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteProphete()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import store from "../../../store/image";

import {
  mdiLockOpen,
  mdiLock,
  mdiPlus,
  mdiDeleteOutline,
  mdiPencil,
  mdiDatabasePlusOutline,
} from "@mdi/js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import Constant from "@/utils/constants";
import { getAllProphete, getAllTheme } from "@/views/qorani/services/services";
import { log } from "util";
export default {
  components: { VueUploadMultipleImage },
  data() {
    return {
      isLocked: false,
      search: "",
      isLoadingTables: false,
      showlowding: false,
      addCard: false,
      loadingbtn: false,
      svgContent: "",
      icons: {
        mdiLockOpen,
        mdiLock,
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
      },

      PropheteName: "",
      PropheteNameEn: "",
      prophete: {
        name: "",
        nameEn: "",
        imgDBUrlId: "",
        dateBirth: "",
        isLocked: false,
      },
      dialogAddProphete: false,
      PropheteArray: [],

      headers: [
        { text: "Image", value: "imageUrl" },
        { text: "Nom", value: "name" },
        { text: "Nom en anglais", value: "nameEn" },
        { text: "Premium", value: "isLocked" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      dialogDeleteProphete: false,
      images: [],
      imagesUpload: [],
      imageUrl: "",
      imageId: "",
      isButtonLoading: false,
      idPropheteSupprimmer: "",
      themeArray: [],
      theme: null,
      fakePercentage: null,
      uploadPercentage: null,
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
    };
  },
  methods: {
     async loadImage(item) {
      console.log(item);
      
      if (item.imgDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.imgDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          item.svgContent = svgContent; // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        item.imgUrl = `${Constant.QORANI}fileDB/files/${item.imgDBId}`;
      }
    },
    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    redirectToEditProphete(item) {
      this.$router.push({
        name: "EditSousTheme",
        params: { id: item.id, item: item },
      });
    },
    suppressionAction(item) {
      this.idPropheteSupprimmer = item;
      // this.dialogDeleteProphete = true;
      this.deleteProphete();
    },
    async deleteProphete() {
      const responseCategorie = await fetch(
        Constant.QORANI + `prophete/delete/${this.idPropheteSupprimmer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteProphete = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteProphete = false;
      }
    },
    async ajoutProphete() {
      const imageId = store.state.imageId;

      if (!this.prophete.imgDBUrlId) {
        alert("L'image est obligatoire. Veuillez télécharger une image.");
        this.dialogAddProphete = false;
        return;
      }

      console.log("Preparing to add Prophete data:");
      console.log("Name:", this.PropheteName);
      console.log("Image ID:", imageId);
      console.log("Is Locked:", this.isLocked);

      this.prophete.name = this.PropheteName;
      this.prophete.nameEn = this.PropheteNameEn;
      this.prophete.isLocked = this.isLocked;
      console.log("Prophete object being sent:", this.prophete);

      const responseProphete = await fetch(Constant.QORANI + "prophete/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.prophete),
      });
      console.log("Response from adding Prophete:", responseProphete);
      console.log("Response status:", responseProphete.ok);
      if (responseProphete.ok) {
        if (this.theme) {
          const propheteData = await responseProphete.json();

          const addThemeUrl = `${Constant.QORANI}theme/addProphete/${propheteData.id}/to/${this.theme}`;

          const responseTheme = await fetch(addThemeUrl, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (!responseTheme.ok) {
            alert(
              "Une erreur est survenue lors de l'association du thème, veuillez réessayer plus tard, Merci."
            );
            return;
          }
        }
        try {
          // window.location.reload();
        } catch (error) {
          alert(
            "Une erreur est survenue lors de l'ajout du theme, veuillez réessayez plus tard, Merci."
          );
        }
      }
    },
    validate() {
      if (!this.prophete.imgDBUrlId) {
        alert("Veuillez télécharger une image avant de continuer.");
        return;
      }
      if (this.$refs.form.validate()) {
        this.dialogAddProphete = true;
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddProphete = false;
      this.imageId = "";
      this.imageUrl = "";
      this.images = [];
      this.imagesUpload = [];
      this.$refs.form.reset();
    },

    handleImagesUpdated(images) {
      const uploadedImage = images[0];
      console.log("Uploaded image:", uploadedImage);
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.prophete.imgDBUrlId = imageId;
        console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },

    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUpload.indexOf(
          fileList[index].path
        );
        this.imageUrl = "";
        this.imageId = "";
        if (index > -1) {
          this.imagesUpload.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    convertImagePathToFile(element) {
      const byteString = atob(element.path.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/jpeg" });

      return new File([blob], element.name);
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.PropheteArray = await getAllProphete();
    this.themeArray = await getAllTheme();
    this.PropheteArray.forEach(async(Prophete) => {
      if (Prophete.imgDBType) {
        await this.loadImage(Prophete);
      }
    });
    this.isLoadingTables = false;
  },
};
</script>
